export interface QuickActionsState {
    isEnabled: boolean;
    selectedType: string;
}

export interface QuickActionsTypes extends QuickActionsState {}

export const ENABLE_QUICK_ACTIONS = "ENABLE_QUICK_ACTIONS";
export const DISABLE_QUICK_ACTIONS = "DISABLE_QUICK_ACTIONS";
export const SET_SELECTED_TYPE = "SET_SELECTED_TYPE";
export const RESET_QUICK_ACTIONS = "RESET_QUICK_ACTIONS";

export interface EnableQuickActionsAction {
    type: typeof ENABLE_QUICK_ACTIONS;
}

export interface DisableQuickActionsAction {
    type: typeof DISABLE_QUICK_ACTIONS;
}

export interface SetSelectedTypeAction {
    type: typeof SET_SELECTED_TYPE;
    payload: { selectedType: string };
}

export interface ResetQuickActionsAction {
    type: typeof RESET_QUICK_ACTIONS;
}
